<template>
    <div>
        <h1>Service Fees</h1>
        <p v-show="thinking">Loading...</p>

        <!-- Data Table -->
        <table v-if="!thinking">
            <tr>
                <th>Locker Doors</th>
                <th>Apartments</th>
                <th>Service Fee ($)</th>
                <th>Silver Fee ($)</th>
                <th>Gold Fee ($)</th>
                <th>Platinum Fee ($)</th>
                <th>Options</th>
            </tr>
            <tr v-for="i in service_fees" :key="i.id">
                <td><input type="number" class="width_third" v-model="i.min_doors" /> to <input type="number" class="width_third" v-model="i.max_doors" /></td>
                <td><input type="number" class="width_third" v-model="i.min_apartments" /> to <input type="number" class="width_third" v-model="i.max_apartments" /></td>
                <td>$ <input type="number" class="width_half" step=".01" v-model="i.service_fee" /></td>
                <td>$ <input type="number" class="width_half" step=".01" v-model="i.fee_silver" /></td>
                <td>$ <input type="number" class="width_half" step=".01" v-model="i.fee_gold" /></td>
                <td>$ <input type="number" class="width_half" step=".01" v-model="i.fee_platinum" /></td>
                <td><button @click="delRow(i)">&#10006;</button></td>
            </tr>
        </table>
        
        <!-- Action Buttons -->
        <button @click="updateFees()" class="pull-right">Save Changes</button>
        <button @click="addRow()" class="pull-right">New Row</button>
    </div>
</template>

<script>
    // Import Helpers
    import {CallApi} from '../Utilities.js'

        
        export default {
        // Module Data
            data:  function () {
            return {
                thinking:true,
                service_fees: [],
            }
        },

        // Functionality
        methods: {
            addRow: function() {
                this.service_fees.push({
                    min_doors: 0,
                    max_doors: 0,
                    min_apartments: 0,
                    max_apartments: 0,
                    service_fee: 0,
                    fee_silver: 0,
                    fee_gold: 0,
                    fee_platinum: 0,
                });
            },
            delRow: function(r) {
                this.service_fees = this.service_fees.filter(item => item !== r)
                console.log(this.service_fees)
            },
            getFees: async function() {
                this.thinking = true
                const apiResult = await CallApi("GET", "/fees")
                this.service_fees = apiResult.service_fees
                console.log(this.service_fees);
                this.thinking = false
            },
            updateFees: async function() {
                if (window.confirm("Warning! This will erase all services fees from the system, and replace them with exactly what is shown here. Continue?") !== true)
                    return
                this.thinking = true
                await CallApi('POST', "/fees/update", {service_fees:this.service_fees})
                this.getFees()
                this.thinking = false
            },
        },

        // On Load, Get the Service Fees
        mounted: function() {
            this.getFees()
        }
    }

</script>

<style>
.pull-right {
    float: right;
    margin-left: 1rem;
}
input.width_third {
    width: 30%;
}

input.width_half {
    width: 60%;
}
</style>